export function findLockerByCode(lockers, locker_code) {
    if (!locker_code) {
        return null;
    }

    const locker = lockers.find((item) => `${item.col}-${item.row}` === locker_code);

    if (locker) {
        return locker;
    }

    return lockers.find((item) => item.merge?.some((merged_locker_slug) => {
        const parts = merged_locker_slug.split('-');

        if (parts.length < 4) {
            return false;
        }

        const row = parts[parts.length - 1].substring(1);
        const col = parts[parts.length - 2].substring(1);

        return `${col}-${row}` === locker_code;
    })) ?? null;
}
